module.exports = __webpack_public_path__ + "static/media/S1-26-Kytrov-cod46.55de9199.png";